module.exports = __webpack_public_path__ + "img/listing-rekomendasi.abb8b2fa.svg";